import { withTranslation } from "next-i18next";
import { Button, Image, Link } from "@components/core";

function DrawerSubscriptionCanceled({ t }) {
  return [
    <div className="drawer-body bg-white p-4" key="drawer-subscription-canceled-body">
      <div className="p-2 mb-4 text-center">
        <h5 className="mb-2">{t("common:drawer.modal_canceled.title")}</h5>
        <p className="mb-0 text-gray">{t("common:drawer.modal_canceled.subtitle")}</p>
      </div>
      <div style={{ width: "128px" }} className="mx-auto">
        <Image
          src="handbagHappyNeon"
          alt={t("common:drawer.modal_canceled.img_alt")}
          className="w-100"
        />
      </div>

      <div className="py-4 m-2">
        <p className="mb-0 text-center text-gray">
          {t("common:drawer.modal_canceled.explanation")}
        </p>
      </div>
    </div>,
    <div className="bg-white p-3 border-top" key="drawer-subscription-canceled-footer">
      <Link href="/je-commence/ready-to-subscribe">
        <Button
          fullWidth
        >
          {t("common:drawer.modal_canceled.restart_now")}
        </Button>
      </Link>
    </div>,
  ];
}

export default withTranslation("common")(DrawerSubscriptionCanceled);
